module.exports = __webpack_public_path__ + "img/media-placeholder.6a9d678d.png";